import { Component, OnInit } from '@angular/core';
import { NavParams, PopoverController } from '@ionic/angular';
import { Router } from '@angular/router';
import { NavUrls } from '../../../enums/nav-urls';
import { AlertService, AlertDialogButtonClick } from '../../../services/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { LocationService } from '../../../services/location.service';
import { LocationV2Dto } from 'src/app/api/exa';

@Component({
  selector: '',
  templateUrl: './location-context-menu.component.html',
  styleUrls: ['../popover.component.scss'],
})
export class LocationContextMenuComponent {
  // @Input()
  location_id: number;
  hasLocationWriteGrant: boolean;
  location: LocationV2Dto;

  constructor(
    private navParams: NavParams,
    private router: Router,
    private popoverController: PopoverController,
    private alertService: AlertService,
    private locationService: LocationService,
    private translate: TranslateService
  ) {
    this.location_id = this.navParams.data.location_id;
    this.location = this.navParams.data.location;
    this.hasLocationWriteGrant = this.navParams.data.hasGrantToWriteLocation;
  }

  onClickEditGeometry() {
    let editLocationUrl = NavUrls.LOCATIONS + '/' + NavUrls.ADDEDITLOCATIONGEOMETRY + '/' + this.location_id;
    this.router.navigateByUrl(editLocationUrl);

    this.DismissClick();
  }

  onClickEditInformation() {
    let addEditLocationUrl = NavUrls.LOCATIONS + '/' + NavUrls.ADDEDITLOCATIONINFORMATION + '/' + this.location_id;
    this.router.navigateByUrl(addEditLocationUrl);
    this.DismissClick();
  }

  onClickActivate() {
    this.location.active = true;
    this.locationService.updateLocation(this.location).then(
      (ret) => {
        console.log(' return: ', ret);
        this.DismissClick();
      },
      (err) => {
        console.log(' return: ', err);
      }
    );
  }

  onClickDeactivate() {
    this.location.active = false;
    this.locationService.updateLocation(this.location).then(
      (ret) => {
        console.log(' return: ', ret);
        this.DismissClick();
      },
      (err) => {
        console.log(' return: ', err);
      }
    );
  }

  onClickDelete() {
    let locationId = this.location_id;
    this.alertService
      .presentConfirmAlert(this.translate.instant('WARNING'), this.translate.instant('LOCATION.DELETE.QUESTION'))
      .then((buttonClick) => {
        if (buttonClick == AlertDialogButtonClick.OK) {
          this.locationService.deleteLocation(locationId).finally(() => {
            // egal was passiert das popover schliesst sich
            this.DismissClick();
          });
        }
      });
  }

  async DismissClick() {
    // dismiss the popover
    await this.popoverController.dismiss();
  }
}
